import '../AVIChartCommon.scss';
import './AVITableTile.scss';

import React, { Component } from 'react';

import { AVIDashboardDimContext } from './AVIDashboardDimContext';
import { DimUtils } from '../ChartUtils/DimUtils';
import PropTypes from 'prop-types';
import { json2excel } from 'js2excel';

export class AVITableTileBase extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    getTableData: PropTypes.func.isRequired,
    dims: PropTypes.object,
    width: PropTypes.number,
    height: PropTypes.number,
    children: PropTypes.any,
    description: PropTypes.string,
    showToolbar: PropTypes.bool,
    useFlex: PropTypes.bool
  };

  static defaultProps = {
    width: 4,
    showToolbar: true,
    useFlex: false
  };

  constructor (props) {
    super(props);
    this.downloadTable = this.downloadTable.bind(this);
  }

  pad (s, n) {
    s = '' + s;
    while (s.length < n) {
      s = '0' + s;
    }
    return s;
  }

  getTimestamp () {
    var d = new Date();
    var str = '' + d.getFullYear();
    str += this.pad(d.getMonth() + 1, 2);
    str += this.pad(d.getDay(), 2);
    str += this.pad(d.getHours(), 2);
    str += this.pad(d.getMinutes(), 2);
    return str;
  }

  downloadTable () {
    const { title, getTableData } = this.props;

    var ltitle = title.substring(0, 17) + '-' + this.getTimestamp();

    try {
      var data = getTableData();

      // NB! Varianle carrying data must be named 'data' in object below
      json2excel({
        data,
        name: ltitle,
        formateDate: 'yyyy/mm/dd'
      });
    } catch (e) {
      console.error('Error exporting table' + e);
    }
  }

  render () {
    const { children, title, description, width, height = 1, dims, showToolbar, useFlex } = this.props;

    var hws = DimUtils.getDims(dims, width, height);
    let tableTileStyleWidth = {};

    if (useFlex) {
      tableTileStyleWidth = {
        flex: width
      };
    } else {
      tableTileStyleWidth = {
        width: '100%',
        margin: hws.spacing
      };
    }

    return (
      <div className='avi-table-tile' style={tableTileStyleWidth}>
        <div className='avi-table-header'>
          <h4>{title}</h4>
          {description && <p>{description}</p>}
        </div>
        <div
          className='avi-table-container'
        >
          {children}
        </div>
        {showToolbar && (
          <div className='avi-clear-both no-print avi-table-footer'>
            <button className='avi-chart-action-link' onClick={this.downloadTable}>
                Last ned tabell (MS Excel)
            </button>
          </div>
        )}
      </div>
    );
  }
}

const AVITableTile = function (props) {
  return (
    <AVIDashboardDimContext.Consumer>
      {dims => <AVITableTileBase {...props} dims={dims} />}
    </AVIDashboardDimContext.Consumer>
  );
};

export { AVITableTile };
